import { getApv } from '../../apis';
import { SDK_DOMAIN } from '../../constants';
import { setAddEventListener } from '../../helpers';
import { pushRouter, routes } from '../../router';
import { setDisableBackControl } from '../../utils/back-control';

const Settings = {
  render: async () => {
    return `
      <div>
        <a id="connect_pay_back_button" class="c_back"></a>
      </div>
      <div class="c_title1">커넥트페이 관리</div>
      <div id="pay_method" class="m_b_20 c_box">
        <label class="form-check-label c_label5">결제수단 관리</label>
        <a href="" class="c_more1"><img src="${SDK_DOMAIN}/images/icon_more.svg" /></a>
      </div>
      <div id="enter_pwd" class="m_b_20 c_box">
        <label class="form-check-label c_label5">결제 비밀번호 설정</label>
        <a href="" class="c_more1"><img src="${SDK_DOMAIN}/images/icon_more.svg" /></a>
      </div>
      <div id="charg_deposit_auto" class="m_b_20 c_box">
        <label class="form-check-label c_label5">충전머니 자동충전 설정</label>
        <a href="" class="c_more1"><img src="${SDK_DOMAIN}/images/icon_more.svg" /></a>
      </div>
      <div id="payment-details" class="m_b_20 c_box">
        <label class="form-check-label c_label5">결제 내역조회</label>
        <a href="" class="c_more1"><img src="${SDK_DOMAIN}/images/icon_more.svg" /></a>
      </div>
      <div id="charg-details" class="m_b_20 c_box">
        <label class="form-check-label c_label5">충전머니 내역조회</label>
        <a href="" class="c_more1"><img src="${SDK_DOMAIN}/images/icon_more.svg" /></a>
      </div>
      <div id="cash_receipt" class="m_b_20 c_box">
        <label class="form-check-label c_label5">현금영수증 설정</label>
        <a href="" class="c_more1"><img src="${SDK_DOMAIN}/images/icon_more.svg" /></a>
      </div>
      <div id="agreement_open_banking" class="m_b_20 c_box">
        <label class="form-check-label c_label5">오픈뱅킹 이용 동의</label>
        <a href="" class="c_more1"><img src="${SDK_DOMAIN}/images/icon_more.svg" /></a>
      </div>
    `;
  },
  afterRender: async () => {
    setAddEventListener('connect_pay_back_button', () => history.back());
    setAddEventListener('pay_method', () =>
      pushRouter(null, null, routes.payMethod.hashPath)
    );
    setAddEventListener('enter_pwd', async () => {
      // PIN 등록여부
      let existPin = true;
      try {
        await getApv('common/pinRegCheck');
      } catch (e) {
        existPin = false;
      } finally {
        // PIN 등록 상태 -> PIN 확인 -> PIN 수정(등록) -> 관리 화면
        if (existPin) {
          pushRouter(
            {
              mode: 'PIN_CHECK',
              nextHash: routes.enterPwd.hashPath,
              nextState: {
                mode: 'PIN_STEP_1',
                nextHash: routes.settings.hashPath,
              },
            },
            null,
            routes.enterPwd.hashPath,
            () => {
              setDisableBackControl();
            }
          );
        }
        // PIN 미등록 -> PIN 등록 -> 관리 화면
        else {
          pushRouter(
            {
              mode: 'PIN_STEP_1',
              nextHash: routes.settings.hashPath,
            },
            null,
            routes.enterPwd.hashPath,
            () => {
              setDisableBackControl();
            }
          );
        }
      }
    });
    setAddEventListener('charg_deposit_auto', () =>
      pushRouter(null, null, routes.chargDepositAuto.hashPath)
    );
    setAddEventListener('payment-details', () =>
      pushRouter(null, null, routes.paymentDetails.hashPath)
    );
    setAddEventListener('charg-details', () =>
      pushRouter(null, null, routes.chargDetails.hashPath)
    );
    setAddEventListener('cash_receipt', () =>
      pushRouter(null, null, routes.cashReceipt.hashPath)
    );
    setAddEventListener('agreement_open_banking', () =>
      pushRouter(null, null, routes.agreementOpenBanking.hashPath)
    );
  },
};
export default Settings;
